import styled from '@emotion/styled';

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px 24px;
  padding: 20px 16px;
`;
